import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS_SUCCESS,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS_ERROR,
  ADD_INSTALLATION_CUSTOMER_ACCESSWAY,
  ADD_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS,
  ADD_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR,
  UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY,
  UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS,
  UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR,
  DELETE_INSTALLATION_CUSTOMER_ACCESSWAY,
  DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS,
  DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR,
  TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT,
  TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_ERROR,
  TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS,
} from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.installationCustomerAccessway;
const installationCustomerAccessway = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addInstallationCustomerAccessway':
          key = 'add';
          break;
        case 'updateInstallationCustomerAccessway':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST ACCESS WAYS
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: null,
        },
      };
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: action.data,
        },
      };
    // ADD ACCESS WAY
    case ADD_INSTALLATION_CUSTOMER_ACCESSWAY:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          idCustomer: action.idCustomer,
          error: null,
        },
      };
    case ADD_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          asyncOperation: action.data.data,
        },
      };
    // UPDATE ACCESS WAY
    case UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          idCustomer: action.idCustomer,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // DELETE ACCESS WAY
    case DELETE_INSTALLATION_CUSTOMER_ACCESSWAY:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          idCustomer: action.idCustomer,
          idAccessWay: action.idAccessWay,
          error: null,
        },
      };
    case DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          asyncOperation: action.data.data,
        },
      };
    // TRIGGER ACCESS WAY RIGHT
    case TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT:
      return {
        ...state,
        triggerRight: {
          ...state.triggerRight,
          idRight: action.idRight,
          done: false,
          error: null,
        },
      };
    case TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_ERROR:
      return {
        ...state,
        triggerRight: {
          ...state.triggerRight,
          error: action.error,
        },
      };
    case TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS:
      return {
        ...state,
        triggerRight: {
          ...state.triggerRight,
          done: true,
          asyncOperation: action.data.data,
        },
      };
    default:
      return state;
  }
};

export default installationCustomerAccessway;



// WEBPACK FOOTER //
// ./reducers/installation/installationCustomerAccessway.js